export default __webpack_public_path__ + "static/media/AE21.f2ebdad5.jpg";